import React from 'react';
import { getImageUrl } from '../config/imageConfig';
import CarouselBanner from './common/CarouselBanner';
import './About.css';

function About() {
  // 图片资源
  const aboutHeroImg = getImageUrl('https://images.unsplash.com/photo-1441974231531-c6227db76b6e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80');

  return (
    <div className="about-page">
      {/* Hero Section - 使用轮播图组件 */}
      <CarouselBanner 
        categoryNameEn="GYWM"
        defaultImage={aboutHeroImg}
        defaultTitle="关于我们"
        defaultSubtitle="庐山杏林中药植物研究所 · 传承九十载植物科学精神"
        className="hero-section"
      />
      
      <div className="about-container">
        {/* 植物园简介 */}
        <section className="garden-intro">
          <div className="intro-header">
            <h2>庐山杏林中药植物研究所</h2>
            <div className="header-divider"></div>
          </div>
          
          <div className="intro-content">
            <p className="intro-text">
              庐山杏林中药植物研究所成立于1934年，坐落于风景秀丽的庐山脚下，是中国最早的植物研究机构之一。
              研究所依托庐山得天独厚的自然环境和丰富的植物资源，九十年来始终致力于中药植物的保护、研究和科普教育工作。
            </p>
            
            <p className="intro-text">
              我们的使命是保护珍稀植物资源，传承中医药文化，推动中药植物科学研究的创新与发展。
              通过建立完善的植物资源库和科研平台，我们为中医药事业的可持续发展贡献力量。
            </p>
          </div>
        </section>

        {/* 特色亮点 */}
        <section className="highlights-section">
          <div className="highlights-grid">
            <div className="highlight-card">
              <div className="highlight-icon">🏛️</div>
              <h3>悠久历史</h3>
              <p>始建于1934年<br/>传承90余年植物科学精神</p>
            </div>
            
            <div className="highlight-card">
              <div className="highlight-icon">🌿</div>
              <h3>丰富资源</h3>
              <p>收集保存1000余种<br/>珍稀中药植物资源</p>
            </div>
            
            <div className="highlight-card">
              <div className="highlight-icon">🔬</div>
              <h3>科研实力</h3>
              <p>省级重点实验室<br/>专业科研团队</p>
            </div>
            
            <div className="highlight-card">
              <div className="highlight-icon">📚</div>
              <h3>科普教育</h3>
              <p>开展中医药科普<br/>传承传统文化</p>
            </div>
          </div>
        </section>

        {/* 核心价值 */}
        <section className="values-section">
          <h2 className="section-title">我们的核心价值</h2>
          
          <div className="values-grid">
            <div className="value-item">
              <div className="value-number">01</div>
              <h3>保护传承</h3>
              <p>保护珍稀濒危中药植物资源，传承中医药传统文化，为子孙后代留下宝贵的自然遗产。</p>
            </div>
            
            <div className="value-item">
              <div className="value-number">02</div>
              <h3>科研创新</h3>
              <p>开展中药植物基础研究和应用研究，推动中医药科技创新，服务健康中国战略。</p>
            </div>
            
            <div className="value-item">
              <div className="value-number">03</div>
              <h3>科普教育</h3>
              <p>面向公众普及中医药知识，提升全民健康素养，弘扬中华优秀传统文化。</p>
            </div>
          </div>
        </section>

        {/* 参观信息 */}
        <section className="visit-info">
          <div className="info-card">
            <h3>欢迎参观</h3>
            <p>我们诚挚欢迎您来到庐山杏林中药植物研究所参观交流</p>
            <div className="info-details">
              <div className="info-item">
                <span className="info-label">开放时间</span>
                <span className="info-value">周一至周日 8:00-17:00</span>
              </div>
              <div className="info-item">
                <span className="info-label">联系电话</span>
                <span className="info-value">
                  <a href="tel:0792-2188999" style={{color: 'white', textDecoration: 'none'}}>0792-2188999</a>
                  {' 或 '}
                  <a href="tel:0792-2199888" style={{color: 'white', textDecoration: 'none'}}>0792-2199888</a>
                </span>
              </div>
              <div className="info-item">
                <span className="info-label">地址位置</span>
                <span className="info-value">江西省九江市庐山市</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default About;